import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import Rich, { Lazyload, createAPI } from '@didi/rich-ui'
import Locale from '@didi/rich-ui/lib/locale'
import enUSMessages from '@didi/rich-ui/lib/locale/lang/en-US'
import esMXMessages from '@didi/rich-ui/lib/locale/lang/es-MX'
import store from './store'
import initGlobalFilters from './filters'
import initGlobalDirectives from './directives'
import Viewer from 'v-viewer'
import { trackEvent } from '@/common/utils/log'
// import storage from 'didi-store'
import { i18n, setBDLocale, setBDCountry } from './common/utils/i18n'
import FullScreenSelect from '@/components/FullScreenSelect.vue'
import FullScreenBizTime from '@/components/FullScreenBizTime.vue'
import FullScreenPoiPicker from '@/components/FullScreenPoiPicker.vue'
import FullScreenVisitObject from '@/components/FullScreenVisitObject.vue'
import vueI18n from '@/i18n/locale'
import storage from 'didi-store'
let isPro = process.env.NODE_ENV === 'production'

// NOTE: 该功能已经废弃，但因为[历史原因]，我们给予保留吧
export default function() {
  window.SodaBD.getMulti(
    ['userInfo', 'ticket', 'areaGroup', 'currentLocation'],
    function(data) {
      console.log('getMulti', data)
      let { userInfo, ticket, areaGroup, currentLocation } = data
      userInfo = JSON.parse(userInfo)
      areaGroup = JSON.parse(areaGroup)
      currentLocation = JSON.parse(currentLocation)
      let { locale, country } = userInfo
      if (!locale) locale = 'en-US'
      setBDLocale(locale)
      setBDCountry(country)
      storage.set('language', locale) // 新增代码

      const messageMap = {
        'en-US': enUSMessages,
        'es-MX': esMXMessages,
        'pt-BR': enUSMessages
      }
      // 前置init app
      Vue.use(Vuex)
      Vue.use(Rich)
      Vue.use(Viewer)
      Vue.use(Lazyload, {
        preload: 1,
        attempt: 3,
        filter: {
          progressive(listener, options) {
            const size = listener.el.getAttribute('crop-size')
            // SODA 图床暂只支持soda-public的服务
            const isSodaPublic = /soda-public/
            if (size && isSodaPublic.test(listener.src)) {
              listener.src = `${listener.src}!${size}_m`
            }
          }
        }
      })
      Vue.use(Locale)
      initGlobalFilters()
      initGlobalDirectives()
      Vue.use(i18n.plugin)
      Locale.use(locale, messageMap[locale])
      createAPI(Vue, FullScreenSelect, ['click'], true)
      createAPI(Vue, FullScreenBizTime, ['click'], true)
      createAPI(Vue, FullScreenPoiPicker, ['click'], true)
      createAPI(Vue, FullScreenVisitObject, ['click', true])

      let loginData = {
        ticket
      }
      store.dispatch('updateLoginData', Object.assign(loginData, { userInfo }))
      store.commit('updateAreaGroup', areaGroup)
      store.commit('updateGeo', currentLocation)
      const _router = router(country || 'MX')
      /* eslint-disable no-new */
      new Vue({
        el: '#app',
        i18n: vueI18n,
        store,
        router: _router,
        template: '<App/>',
        components: { App }
      })
      _router.beforeEach(async (to, from, next) => {
        next()
        if (window.Omega && isPro) {
          window.Omega.sendPageView && window.Omega.sendPageView()
          trackEvent('sailing_gattarman_x_page_leave', {
            pageName: from.name
          })
          trackEvent('sailing_gattarman_x_page_entry', {
            pageName: to.name
          })
        }
      })
    }
  )
}
